exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".execution-status-section ul.trigger-details.artifacts li {\n  margin-bottom: 4px;\n}\n.execution-status-section ul.trigger-details.artifacts div {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: inherit;\n  height: 12px;\n}\n.execution-status-section ul.trigger-details.artifacts dl {\n  margin: 0;\n}\n.execution-status-section ul.trigger-details.artifacts dd,\n.execution-status-section ul.trigger-details.artifacts dt {\n  display: inline;\n}\n.execution-status-section ul.trigger-details.artifacts dt {\n  font-weight: normal;\n  padding: 0 4px 0 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/pipeline/status/artifactList.less
// module id = 2607
// module chunks = 0